import { computed, ref } from 'vue'

import { getPagePartColumns } from '@/controllers/library/page'

const TAG_COLUMN_WIDTH = 100
const UNKNOWN_COLUMN_WIDTH_ESTIMATE = 120

export function usePartCollectionColumns() {
  const partColumns = ref<string[]>([])

  const effectivePartColumns = computed(() => {
    const colsToExclude = new Set(['uom'])
    const cols = partColumns.value.length > 0
      ? partColumns.value
      : ['partNumber', 'name', 'quantity', 'retailPrice']

    return cols.filter(column => !colsToExclude.has(column))
  })

  const columnWidths = computed<Record<string, number>>(() => {
    const widths: Record<string, number> = {}

    for (const column of effectivePartColumns.value) {
      if (column === 'partNumber') {
        widths[column] = 120
      } else if (column === 'name') {
        widths[column] = 180
      } else if (column === 'quantity') {
        widths[column] = 80
      } else if (column === 'retailPrice' || column === 'wholesalePrice' || column === 'discountPrice') {
        widths[column] = 120
      } else if (column.startsWith('tag:')) {
        widths[column] = TAG_COLUMN_WIDTH
      }
      // Unknown columns intentionally omitted — CSS max-width drives their visual size
    }

    return widths
  })

  const contentWidth = computed(() => {
    const total = effectivePartColumns.value.reduce((sum, column) => {
      return sum + (columnWidths.value[column] ?? UNKNOWN_COLUMN_WIDTH_ESTIMATE)
    }, 0)

    return Math.max(total + 20, 600)
  })

  async function loadPartColumns() {
    partColumns.value = await getPagePartColumns()
  }

  return {
    partColumns,
    effectivePartColumns,
    columnWidths,
    contentWidth,
    loadPartColumns
  }
}
